import urlPrefix from "./apiPrefix";

export const putTaxSystemUpdate = () => `${urlPrefix.value}/tax-web-control/api/tax-system/update`;
export const postTaxSystemCreate = () => `${urlPrefix.value}/tax-web-control/api/tax-system/create`;
export const getTaxSystem = (id: number) => `${urlPrefix.value}/tax-web-control/api/tax-system/${id}`;
export const getTaxSystemList = () => `${urlPrefix.value}/tax-web-control/api/tax-system/list`;
export const getTaxSystemListActive = () => `${urlPrefix.value}/tax-web-control/api/tax-system/listActive`;
export const deleteTaxSystem = (id: number) => `${urlPrefix.value}/tax-web-control/api/tax-system/delete/${id}`;
